module.exports = __webpack_public_path__ + "static/img/4.055b1b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/eng/4.png
// module id = Jqwj
// module chunks = 0